import type { TeacherListElementVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveTeachers = createApiThunk<TeacherListElementVM[], void>(
  "teachers/adminRetrieveTeachers",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listTeachers();
  },
);
